import { ReactNode } from "react";
import { Box, IconButton, SxProps, Theme, Tooltip, useTheme } from "@mui/material";

interface ClickableIconProps {
  title: string;
  children?: ReactNode;
  disabled?: boolean;
  disableInteractive?: boolean;
  size?: "small" | "medium" | "large";
  outerSX?: SxProps<Theme>;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function ClickableIcon(props: ClickableIconProps) {
  const { title, children, disabled, disableInteractive, size = "medium", outerSX, onClick } = props;
  const theme = useTheme();
  const padding = size === "large" ? "12px" : size === "medium" ? "8px" : "3px";
  const width = size === "large" ? "50px" : size === "medium" ? "40px" : "30px";

  return (
    <Box sx={{ ...outerSX, display: "inline-flex", width: width, height: width }}>
      <Tooltip title={title} disableInteractive={disableInteractive}>
        {/* <span style={{ width: width, height: width }}> */}
        <IconButton
          disabled={disabled}
          onClick={(event) => onClick(event)}
          edge="end"
          color='inherit'
          size={size}
          sx={{ p: padding, "&:hover": { backgroundColor: theme.palette.mode === "dark" ? "#232323" : "" } }}
        >
          {children}
        </IconButton>
        {/* </span> */}
      </Tooltip>
    </Box>
  )
}